import React from 'react';
import { Typography } from '@mui/material';
import { GuideSection } from '../common/GuideSection';
import { GuideSubsection } from '../common/GuideSubsection';
import { StepByStep } from '../common/StepByStep';
import { Tip } from '../common/Tip';
import { Warning } from '../common/Warning';
import { useTranslation } from '../../../i18n';

export const MaintenanceRecordsSection: React.FC = () => {
  const { t } = useTranslation();

  return (
    <GuideSection id="maintenance-records" title={t('guide.sections.maintenanceRecords')}>
      <Typography variant="body1" sx={{ mb: 1, color: '#555' }}>
        {t('guide.maintenanceRecords.intro')}
      </Typography>
      <Typography variant="body1" sx={{ mb: 2, color: '#555' }}>
        {t('guide.maintenanceRecords.layoutDescription')}
      </Typography>

      <GuideSubsection
        id="maintenance-creating"
        title={t('guide.sections.maintenanceRecordsCreating')}
      >
        <StepByStep
          steps={[
            t('guide.maintenanceRecords.creating.steps.s1'),
            t('guide.maintenanceRecords.creating.steps.s2'),
            t('guide.maintenanceRecords.creating.steps.s3'),
            t('guide.maintenanceRecords.creating.steps.s4'),
            t('guide.maintenanceRecords.creating.steps.s5'),
            t('guide.maintenanceRecords.creating.steps.s6'),
            t('guide.maintenanceRecords.creating.steps.s7'),
            t('guide.maintenanceRecords.creating.steps.s8'),
          ]}
        />
        <Warning>{t('guide.maintenanceRecords.warningAttachments')}</Warning>
        <Tip>{t('guide.maintenanceRecords.tipNewTypes')}</Tip>
      </GuideSubsection>

      <GuideSubsection
        id="maintenance-quality"
        title={t('guide.sections.maintenanceRecordsQuality')}
      >
        <Typography variant="body1" sx={{ mb: 1, color: '#555' }}>
          {t('guide.maintenanceRecords.quality.description')}
        </Typography>
        <Warning>{t('guide.maintenanceRecords.quality.warningDifferentUser')}</Warning>
      </GuideSubsection>

      <GuideSubsection
        id="maintenance-schedules"
        title={t('guide.sections.maintenanceRecordsSchedules')}
      >
        <Typography variant="body1" sx={{ color: '#555' }}>
          {t('guide.maintenanceRecords.schedules.description')}
        </Typography>
      </GuideSubsection>
    </GuideSection>
  );
};
